// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  background-color: rgb(242, 250, 253);
  height: 100%;
  display: flex;
  flex-direction: row;
  background-color: rgb(242, 250, 253);
  padding: 0;
  margin: 0;
}
.max-w-\\[800px\\] {
  max-width: 100% !important;
}
.corner-wrapper {
  display: block;
  overflow: hidden;
  width: 98%;
  /* height: 80vh; */
  height: auto;
  min-height: 80vh;
  border-radius: 1rem;
  transform: translateZ(0px);
  border: 1px solid #dbf3ff;
}
.my-container {
  width: 80vw;
  max-width: 80vw;
  margin-left: 20vw;
}
.nav-link {
  margin: 5px;
  font-weight: 550;
}
.left-column-container {
  display: flex;
  flex-direction: column;
  width: 70%;
  padding: 10px;
  align-items: center;
}
.right-column-container {
  width: 30%;
}
.nav-link-container {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 50%;
}
.sidenav {
  height: 100%;
  width: 20%;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #124991;
  overflow-x: hidden;
  padding-top: 20px;
  align-items: center;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
}
.logo {
  margin-bottom: 2rem;
  width: 80%;
}
.sidenav a {
  padding: 6px 6px 6px 6px;
  text-decoration: none;
  font-size: 0.9rem;
  /* color: #f1f1f1; */
  color: white;
  display: block;
}

.sidenav a:hover {
  color: rgb(0, 152, 255);
}

.main {
  /* margin-left: 250px; Same as the width of the sidenav */
  background-color: rgb(242, 250, 253);
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
}
iframe {
  border: 0px;
  width: 100%; /* takes precedence over the width set with the HTML width attribute */
}
.custom-btn {
  overflow: hidden;
  border: 0.1rem solid white;
  font-family: "Arial";
  font-size: 0.9rem;
  color: white;
  background: none;
  cursor: pointer;
  padding: 0.8rem 1.5rem;
  display: inline-block;
  margin: 15px 30px;
  text-transform: uppercase;
  outline: none;
  position: relative;
  transition: all 0.3s;
  border-radius: 4rem;
  font-weight: 700;
}
.custom-btn:after {
  content: "";
  position: absolute;
  z-index: -1;
  transition: all 0.3s;
  box-sizing: border-box;
}
.btn-03:after {
  width: 0;
  height: 100%;
  top: 0;
  left: 0;
  background: #fff;
}

.btn-03:hover,
.btn-03:active {
  color: #457b9d;
}

.btn-03:hover:after,
.btn-03:active:after {
  width: 100%;
}
.contact-container {
  background-color: black;
  width: 100%;
  height: 10rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
}
#inlineFrameExample {
  min-height: 80vh;
}
@media only screen and (max-width: 900px) {
  .logo {
    margin-bottom: 1rem;
  }
  .sidenav a {
    font-size: 0.6rem;
  }
  .custom-btn {
    font-size: 0.4rem;
    padding: 0.4rem 0.8rem;
  }
  .contact-container {
    font-size: 0.5rem;
    height: 6rem;
  }
  .left-column-container {
    padding: 5px;
  }
}

@media only screen and (min-width: 1300px) {
  .sidenav a {
    font-size: 1.5rem;
  }
  .custom-btn {
    font-size: 1rem;
    padding: 1rem 2rem;
  }
  .contact-container {
    font-size: 1.2rem;
    height: 13rem;
  }
  .logo {
    margin-bottom: 3rem;
  }
}
@media only screen and (min-width: 2000px) {
  .sidenav a {
    font-size: 2rem;
  }

  .sidenav {
    width: 15%;
  }
  .my-container {
    width: 85vw;
    max-width: 85vw;
    margin-left: 15vw;
  }
  .custom-btn {
    font-size: 1.5rem;
    border-width: 0.2rem;
    padding: 1.3rem 2.8rem;
  }
  .nav-link-container {
    margin-bottom: 6rem;
  }
  .left-column-container {
    padding: 3rem;
  }
  #inlineFrameExample {
    transform: scale(calc(100% * 1.5));
    transform-origin: top;
  }
  .corner-wrapper {
    overflow-y: visible;
  }
}
@media only screen and (min-width: 3000px) {
  .nav-link-container {
    height: 50%;
    margin-bottom: 4rem;
  }
  .sidenav a {
    font-size: 3.2rem;
  }
  .custom-btn {
    font-size: 2.5rem;
    border-width: 0.3rem;
    padding: 2rem 4rem;
  }
  .logo {
    margin-bottom: 10rem;
  }
  .contact-container {
    font-size: 2.5rem;
    height: 25rem;
  }
  .left-column-container {
    padding: 5rem;
  }
  #inlineFrameExample {
    transform: scale(calc(100% * 2.5));
    transform-origin: top;
  }
  .corner-wrapper {
    overflow-y: visible;
  }
}
@media only screen and (min-width: 4000px) {
  #inlineFrameExample {
    transform: scale(calc(100% * 3));
    transform-origin: top;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Home/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE;;2DAEyD;EACzD,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,UAAU;EACV,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,UAAU;EACV,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yDAAyD;EACzD,oCAAoC;AACtC;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,WAAW;EACX,WAAW,EAAE,sEAAsE;AACrF;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,QAAQ;EACR,YAAY;EACZ,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,kCAAkC;IAClC,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,kCAAkC;IAClC,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,gCAAgC;IAChC,qBAAqB;EACvB;AACF","sourcesContent":["html {\n  height: 100%;\n}\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  background-color: rgb(242, 250, 253);\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  background-color: rgb(242, 250, 253);\n  padding: 0;\n  margin: 0;\n}\n.max-w-\\[800px\\] {\n  max-width: 100% !important;\n}\n.corner-wrapper {\n  display: block;\n  overflow: hidden;\n  width: 98%;\n  /* height: 80vh; */\n  height: auto;\n  min-height: 80vh;\n  border-radius: 1rem;\n  transform: translateZ(0px);\n  border: 1px solid #dbf3ff;\n}\n.my-container {\n  width: 80vw;\n  max-width: 80vw;\n  margin-left: 20vw;\n}\n.nav-link {\n  margin: 5px;\n  font-weight: 550;\n}\n.left-column-container {\n  display: flex;\n  flex-direction: column;\n  width: 70%;\n  padding: 10px;\n  align-items: center;\n}\n.right-column-container {\n  width: 30%;\n}\n.nav-link-container {\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  height: 50%;\n}\n.sidenav {\n  height: 100%;\n  width: 20%;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  background-color: #124991;\n  overflow-x: hidden;\n  padding-top: 20px;\n  align-items: center;\n  padding-top: 30px;\n  display: flex;\n  flex-direction: column;\n}\n.logo {\n  margin-bottom: 2rem;\n  width: 80%;\n}\n.sidenav a {\n  padding: 6px 6px 6px 6px;\n  text-decoration: none;\n  font-size: 0.9rem;\n  /* color: #f1f1f1; */\n  color: white;\n  display: block;\n}\n\n.sidenav a:hover {\n  color: rgb(0, 152, 255);\n}\n\n.main {\n  /* margin-left: 250px; Same as the width of the sidenav */\n  background-color: rgb(242, 250, 253);\n}\n\n@media screen and (max-height: 450px) {\n  .sidenav {\n    padding-top: 15px;\n  }\n  .sidenav a {\n    font-size: 18px;\n  }\n}\niframe {\n  border: 0px;\n  width: 100%; /* takes precedence over the width set with the HTML width attribute */\n}\n.custom-btn {\n  overflow: hidden;\n  border: 0.1rem solid white;\n  font-family: \"Arial\";\n  font-size: 0.9rem;\n  color: white;\n  background: none;\n  cursor: pointer;\n  padding: 0.8rem 1.5rem;\n  display: inline-block;\n  margin: 15px 30px;\n  text-transform: uppercase;\n  outline: none;\n  position: relative;\n  transition: all 0.3s;\n  border-radius: 4rem;\n  font-weight: 700;\n}\n.custom-btn:after {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  transition: all 0.3s;\n  box-sizing: border-box;\n}\n.btn-03:after {\n  width: 0;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: #fff;\n}\n\n.btn-03:hover,\n.btn-03:active {\n  color: #457b9d;\n}\n\n.btn-03:hover:after,\n.btn-03:active:after {\n  width: 100%;\n}\n.contact-container {\n  background-color: black;\n  width: 100%;\n  height: 10rem;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n}\n#inlineFrameExample {\n  min-height: 80vh;\n}\n@media only screen and (max-width: 900px) {\n  .logo {\n    margin-bottom: 1rem;\n  }\n  .sidenav a {\n    font-size: 0.6rem;\n  }\n  .custom-btn {\n    font-size: 0.4rem;\n    padding: 0.4rem 0.8rem;\n  }\n  .contact-container {\n    font-size: 0.5rem;\n    height: 6rem;\n  }\n  .left-column-container {\n    padding: 5px;\n  }\n}\n\n@media only screen and (min-width: 1300px) {\n  .sidenav a {\n    font-size: 1.5rem;\n  }\n  .custom-btn {\n    font-size: 1rem;\n    padding: 1rem 2rem;\n  }\n  .contact-container {\n    font-size: 1.2rem;\n    height: 13rem;\n  }\n  .logo {\n    margin-bottom: 3rem;\n  }\n}\n@media only screen and (min-width: 2000px) {\n  .sidenav a {\n    font-size: 2rem;\n  }\n\n  .sidenav {\n    width: 15%;\n  }\n  .my-container {\n    width: 85vw;\n    max-width: 85vw;\n    margin-left: 15vw;\n  }\n  .custom-btn {\n    font-size: 1.5rem;\n    border-width: 0.2rem;\n    padding: 1.3rem 2.8rem;\n  }\n  .nav-link-container {\n    margin-bottom: 6rem;\n  }\n  .left-column-container {\n    padding: 3rem;\n  }\n  #inlineFrameExample {\n    transform: scale(calc(100% * 1.5));\n    transform-origin: top;\n  }\n  .corner-wrapper {\n    overflow-y: visible;\n  }\n}\n@media only screen and (min-width: 3000px) {\n  .nav-link-container {\n    height: 50%;\n    margin-bottom: 4rem;\n  }\n  .sidenav a {\n    font-size: 3.2rem;\n  }\n  .custom-btn {\n    font-size: 2.5rem;\n    border-width: 0.3rem;\n    padding: 2rem 4rem;\n  }\n  .logo {\n    margin-bottom: 10rem;\n  }\n  .contact-container {\n    font-size: 2.5rem;\n    height: 25rem;\n  }\n  .left-column-container {\n    padding: 5rem;\n  }\n  #inlineFrameExample {\n    transform: scale(calc(100% * 2.5));\n    transform-origin: top;\n  }\n  .corner-wrapper {\n    overflow-y: visible;\n  }\n}\n@media only screen and (min-width: 4000px) {\n  #inlineFrameExample {\n    transform: scale(calc(100% * 3));\n    transform-origin: top;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
